import React, { useEffect } from "react"
import ss from "../../styles/pages/Main/Products.module.scss"

import { Preloader } from "../../components/Preloader"
import { createSelector } from "reselect"
import { useDispatch, useSelector } from "react-redux"
import ProductCard from "../../components/ProductCard"
import { loadProducts } from "../../actions/products"

export function Products() {
  const isLoadingSelector = (state) => state.products.isLoading
  const productsSelector = (state) => state.products.products
  const activeFilter = (state) => state.sort.activeFilter
  const activeSort = (state) => state.sort.activeSort
  const cartProducts = (state) => state.cart.products

  const filteredProducts = createSelector(productsSelector, activeFilter, (products, activeFilter) => {
    return products.filter((e) => (activeFilter === 0 ? e : e.type === activeFilter))
  })

  const sortedFilteredProducts = createSelector([filteredProducts, activeSort], (filteredProducts, activeSort) => {
    function compireFunction(a, b) {
      switch (activeSort) {
        case 1:
          return a.price - b.price
        case 2:
          return a.title.localeCompare(b.title)
        default:
          return filteredProducts
      }
    }

    return filteredProducts.sort(compireFunction)
  })

  const countOfPizzasInCartSelector = createSelector(cartProducts, (cartProducts) => {
    if (cartProducts.length) {
      const hash = {}
      cartProducts.forEach(({ id, totalCount }) => {
        hash.hasOwnProperty(id) ? (hash[id] += totalCount) : (hash[id] = totalCount)
      })
      return hash
    }
  })

  const productsData = useSelector(sortedFilteredProducts)
  const isLoading = useSelector(isLoadingSelector)
  const countOfPizzasInCart = useSelector(countOfPizzasInCartSelector)
  const dispatch = useDispatch()

  const products = productsData.map((p, i) => (
    <div className={ss.product_card_wrapper} key={p.id}>
      <ProductCard
        count={countOfPizzasInCart ? (p.id in countOfPizzasInCart ? countOfPizzasInCart[p.id] : false) : false}
        product={p}
        index={i}
        id={p.id}
        img={p.img}
        title={p.title}
        price={p.price}
        options={p.options || false}
        selected={p.selected || false}
      />
    </div>
  ))

  useEffect(() => {
    if (products.length === 0) {
      dispatch(loadProducts())
    }
  }, [])

  if (isLoading)
    return (
      <div className={ss.preloader_wrapper}>
        <Preloader />
      </div>
    )

  return <div className={ss.products}>{products}</div>
}
